export default {
  CREATE: `Create a team`,
  DELETE_BUTTON: {
    TITLE: `Delete the team`,
    SUMMARY: `Are you sure you want to delete this team?`,
    PRIMARY_ACTION: `Delete the team`,
    BAD_MATCH: `The input doesn't match "DELETE"`,
    FIELD_IS_REQUIRED: `This field is required`,
    DELETE: {
      LABEL: `Type "DELETE" to confirm`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  LIST: {
    TITLE: `Team list`,
    SUMMARY: ``
  },
  DESCRIPTION: `Description`,
  REPORTS_TO: `Reports to`,
  POSITIONS: `Positions`,
  CSV_EXPORT_NAME: `teams_export_{{date}}`,
  WILL_BE_IMPACTED: `The number of resources that will be impacted (unassigned)`,
  AFFECTED_USERS: `Affected users`,
  form: {
    CREATE: {
      TITLE: `Create a team`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Edit a team`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Team name`,
      DESCRIPTION: `This name should help you quickly identify the team.`,
      PLACEHOLDER: `Enter a name for the team`
    },
    DESCRIPTION: {
      LABEL: `Team description`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Enter the team description`
    },
    IMPORTCODE: {
      LABEL: `Import code`,
      PLACEHOLDER: `Enter the import code`,
      DESCRIPTION: `This will be used in the import tools to assign teams to other resources.`
    },
    REPORTSTO: {
      LABEL: `Reports to`,
      DESCRIPTION: `This will be used to notify team manager when an action impact their teams.`
    },
    POSITIONS: {
      LABEL: `Positions`,
      DESCRIPTION: `These positions will be shown in team view in the schedule.`
    },
    NAME_REQUIRED: `Team's name is mandatory.`,
    NAME_ALREADY_USED: `The name is already used.`
  }
}
